import React from 'react';
import { Flex, Hide } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import SkeletonCard from 'components/SkeletonCard';

const LoaderSkeletonCard = React.memo(() => {
  return (
    <SkeletonCard p={0} width={'100%'}>
      <Hide xs sm md>
        <Flex flexDirection="column" justifyContent="center">
          <Flex flexDirection="row" justifyContent="center">
            <Flex flexDirection="column" justifyContent="flex-start">
              <PulsingLoadingBlock height={480} width={888} borderRadius="default" />
            </Flex>
            <Flex flexDirection="column" justifyContent="flex-start">
              <PulsingLoadingBlock height={238} width={270} borderRadius="default" mr={1} mb={1} />
              <PulsingLoadingBlock height={238} width={270} borderRadius="default" mr={1} mb={0} />
            </Flex>
            <Flex flexDirection="column" justifyContent="flex-start">
              <PulsingLoadingBlock height={238} width={270} borderRadius="default" mr={0} mb={1} />
              <PulsingLoadingBlock height={238} width={270} borderRadius="default" mr={0} mb={0} />
            </Flex>
          </Flex>
        </Flex>
      </Hide>
      <Hide lg xl>
        <PulsingLoadingBlock height={480} width={'100%'} borderRadius="default" />
      </Hide>
    </SkeletonCard>
  );
});

LoaderSkeletonCard.displayName = 'LoaderSkeletonCard';

export default LoaderSkeletonCard;
